/* eslint-disable camelcase */
module.exports = {
	methods: {
		customfeed() {
			const self = this;

			return {
				async list({ offset = 0, limit = self.limit, order_by = null, flushCache = false }) {
					try {
						const headers = {
							Authorization: true,
						};

						if (flushCache) headers['Cache-Control'] = 'no-cache';

						const response = await self.$http.get(
							'customfeed', {
								params: {
									offset,
									limit,
									order_by,
								},
								headers,
							},
						);

						const deals = {
							total: response.data.deals.total,
							results: self.helpers().formatDeals(response.data.deals.results),
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async keywords() {
					try {
						const response = await self.$http.get(
							'customfeed/keywords', {
								headers: {
									Authorization: true,
								},
							},
						);

						return {
							ok: true,
							data: response.data.subscribed_keywords,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async subscribe(tag, type) {
					try {
						if (type === 'keywords') {
							await self.$http.put(
								'customfeed/keywords', {
									keyword: tag,
								}, {
									headers: {
										Authorization: true,
									},
								},
							);
						} else if (type === 'tags') {
							await self.$http.put(
								`tags/${tag}/subscription`, {
									headers: {
										Authorization: true,
									},
								},
							);
						} else {
							return false;
						}

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async unsubscribe(tag, type) {
					try {
						if (type === 'keywords') {
							await self.$http.delete(
								'customfeed/keywords', {
									data: {
										keyword: tag,
									},
									headers: {
										Authorization: true,
									},
								},
							);
						} else if (type === 'tags') {
							await self.$http.delete(
								`tags/${tag}/subscription`, {
									headers: {
										Authorization: true,
									},
								},
							);
						} else {
							return false;
						}

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
			};
		},
	},
};
